/* eslint-disable react/jsx-props-no-spreading */
import React, { memo } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

function DialogContent(props) {
    const {
        children,
        component: Component,
        ...other
    } = props;

    return (
        <Component className={classNames} {...other}>
            {children}
        </Component>
    );
}
// TODO(next16): defaultProps removed in React 19 for function components.
// Convert to inline parameter defaults: const DialogContent = ({prop = val, component = 'div' }) =>

DialogContent.propTypes = {
    component: PropTypes.string,
    children: PropTypes.node.isRequired,
};

export default memo(DialogContent);
